<template>
  <div class="page-container">
    <div v-if="!reportRecordId" class="fixed-header">
      <div class="enterprise-title">
        <div class="back-icon" @click="goBack">
          <span class="back-arrow"></span>
        </div>
        <div class="enterprise-text">贷后管理</div>
      </div>

      <div class="search-container">
        <van-search v-model="searchValue" shape="round" @search="onSearch" @input="handleInput" placeholder="请输入客户名称" class="search-item"/>
        <van-search v-model="bankSearchValue" shape="round" @search="onSearch" @input="handleInput" placeholder="请输入借款银行" class="search-item"/>
      </div>

      <!-- 人员筛选下拉菜单（仅管理员可见） -->
      <div v-if="duty === 3 || duty === 99" class="staff-search-wrapper">
        <div class="staff-select" @click="showStaffPopup = true">
          <span>{{ getSelectedStaffText }}</span>
          <van-icon name="arrow-down" size="16px" color="#999" />
        </div>
        <van-popup v-model="showStaffPopup" position="bottom" round class="staff-popup">
          <div class="popup-header">
            <h3>选择人员</h3>
            <van-icon name="cross" size="20px" @click="showStaffPopup = false" />
          </div>
          <div class="popup-list">
            <div v-for="item in staffOptions" :key="item.id" class="popup-item" @click="selectStaff(item)">
              <span class="popup-item-text">{{ item.name }}</span>
              <van-icon name="arrow" size="16px" color="#999" />
            </div>
            <div v-if="staffOptions.length === 0" class="popup-empty">暂无人员数据</div>
          </div>
        </van-popup>
      </div>

      <!-- 统计信息 -->
      <div class="summary-wrapper">
        <div class="summary-item-1">
          <div class="summary-label">总数量</div>
          <div class="summary-value">{{ loanType === 1 ? (summaryData.enterpriseCount || 0) : (summaryData.personalCount || 0) }}</div>
        </div>
        <div class="summary-item-2">
          <div class="summary-label">总金额</div>
          <div class="summary-value">{{ (loanType === 1 ? (summaryData.enterpriseAmount || 0) : (summaryData.personalAmount || 0)) + "万"  }}</div>
        </div>
      </div>
    </div>

    <div class="content-wrapper" :class="{
      'with-staff-filter': !reportRecordId && (duty === 3 || duty === 99),
      'no-header': reportRecordId
    }">
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh" style="margin-bottom: 80px;">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
        :immediate-check="false"
        :offset="100"
      >
        <template #default>
          <div v-for="(item, index) in customerList" :key="item.id || index" class="enterprise-card" @click="handleItem(item)">
            <div class="enterprise-card-content">
              <div class="enterprise-card-row enterprise-card-row-title">
                <div class="enterprise-card-label">公司名称</div>
                <div class="enterprise-card-value">{{ item.enterpriseName }}</div>
                <van-icon name="edit" color="#176FCA" class="edit-icon" @click.stop="onEdit(item)" />
              </div>
              <div class="enterprise-card-row">
                <div class="enterprise-card-label">客户手机号</div>
                <div class="enterprise-card-value">{{ item.account }}</div>
              </div>
              <div class="enterprise-card-row">
                <div class="enterprise-card-label">跟进人</div>
                <div class="enterprise-card-value">{{ item.salesmanStr }}</div>
              </div>
              <div class="enterprise-card-row">
                <div class="enterprise-card-label">借款银行</div>
                <div class="enterprise-card-value">{{ item.bankName }}</div>
              </div>
              <div class="enterprise-card-row">
                <div class="enterprise-card-label">借款金额</div>
                <div class="enterprise-card-value">{{ formatMoney(item.money) }}</div>
              </div>
              <div class="enterprise-card-row">
                <div class="enterprise-card-label">到期时间</div>
                <div class="enterprise-card-value">{{ formatDateTime(item.loansExpireTime) }}</div>
              </div>
              <div class="enterprise-card-row">
                <div class="enterprise-card-label">备注</div>
                <div class="enterprise-card-value">{{ item.remark }}</div>
              </div>
            </div>
          </div>

          <!-- 空状态 -->
          <div v-if="customerList.length === 0 && !loading" class="empty-state">
            <van-icon name="search" size="64px" color="#c8c9cc" />
            <p class="empty-text">暂无客户数据</p>
          </div>
        </template>
      </van-list>
    </van-pull-refresh>
    </div>

    <!-- 按钮行 -->
    <div class="button-row">
      <van-button type="info" round block @click="showAddDialogFunc" :loading="isOperating" class="btn-get-sub" icon="plus">
        添加
      </van-button>
      <div 
        class="home-button" 
        @click="goToHome"
      v-if="!reportRecordId">
        <van-icon name="wap-home" size="16" />
      </div>
      <div  
      v-if="reportRecordId" style="width: 46px;">
      </div>
    </div>

    <!-- 客户编辑对话框（添加/修改） -->
    <CustomerEditDialog 
      :visible="showEditDialog"
      :reportRecordId="reportRecordId"
      :is-adding="isAdding"
      :client-id="currentClientId"
       :loan-type="currentLoanType"
      @submit-success="onRefresh"
      @update:visible="val => showEditDialog = val"
    />



  </div>
</template>

<script>
import user from '@/utils/user'
import request from '@/utils/request'
import CustomerEditDialog from '@/components/CustomerEditDialog.vue';
import {
  getMyClientPage,
  getCorporationClientPage,
  getAdminClientPage,
} from "@/api/myclient";

export default {
  name: 'CustomerManage',
  components: {
    CustomerEditDialog
  },
  props: {
    loanType: {
      type: Number,
      default: 0
    },
    reportRecordId: {
      type: String,
      default: ''
    },
    showHomeButton: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      duty: -1,
      searchValue: '',
      bankSearchValue: '',
      customerList: [],
      loading: false,
      finished: false,
      refreshing: false,
      showEditDialog: false,
      isAdding: false,
      currentClientId: '',
      currentLoanType: 0,
      listQuery: {
        pageInfo: {
          pageSize: 10,
          page: 1,
          totalCount: 0
        },
        orderBy: "CreateTime",
        orderAsc: false,
        nameLike: "",
        bankName: "",
        reportRecordId: "",
        loanType: 0,
        day: "",
        salesmanId: undefined,
      },
      searchTimer: null,
      userStore: null,
      // 人员筛选相关
      staffOptions: [],
      showStaffPopup: false,
      // 统计数据
      summaryData: {
        totalCount: 0,
        totalAmount: 0
      },
    };
  },
  mounted() {
    // 手动触发首次加载
    this.$nextTick(() => {
      this.onLoad();
    });
    // 添加滚动监听
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeUnmount() {
    // 移除滚动监听
    window.removeEventListener('scroll', this.handleScroll);
    // 清除定时器
    if (this.searchTimer) {
      clearTimeout(this.searchTimer);
    }
  },
  created() {
    this.duty = user.getUserDuty()

    if (this.reportRecordId) {
      this.listQuery.reportRecordId = this.reportRecordId;
    }
    this.listQuery.loanType = this.loanType;

    // 管理员加载人员列表
    if (this.duty === 3 || this.duty === 99) {
      this.getStaffList();
    }
    this.getSummary();
    // 不在这里调用 onLoad，让 van-list 的 immediate-check 触发
  },
  computed: {
    // 计算是否正在操作中
    isOperating() {
      return this.loading || this.refreshing;
    },

    // 获取选中的人员文本
    getSelectedStaffText() {
      if (this.listQuery.salesmanId === undefined || this.listQuery.salesmanId === null) {
        return '请选择人员';
      }
      const selectedOption = this.staffOptions.find(option => option.id === this.listQuery.salesmanId);
      return selectedOption ? selectedOption.name : '请选择人员';
    }

  },
  watch: {
    // 监听 loanType 变化，更新查询条件并重新加载数据
    loanType(newVal) {
      this.listQuery.loanType = newVal;
      this.onRefresh();
    }
  },
  methods: {
    // 滚动处理
    handleScroll() {
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
      const clientHeight = window.innerHeight;

      // 距离底部 100px 时触发加载
      if (scrollHeight - scrollTop - clientHeight < 100) {
        this.onLoad();
      }
    },
    handleItem(item) {
      console.log(item)
      // 点击客户项的处理逻辑
    },

    // 处理输入事件，添加防抖
    handleInput() {
      if (this.searchTimer) {
        clearTimeout(this.searchTimer);
      }
      this.searchTimer = setTimeout(() => {
        this.onSearch();
      }, 500);
    },
    // 搜索客户
    onSearch() {
      this.listQuery.nameLike = this.searchValue;
      this.listQuery.bankName = this.bankSearchValue;
      this.onRefresh();
    },
    // 加载客户列表
    onLoad() {
      // 如果正在加载或已经加载完成，直接返回
      if (this.loading) {
        return;
      }

      if (this.finished) {
        return;
      }

      this.loading = true;

      var filterForm = Object.assign({}, this.listQuery);

      if (this.duty == 1) {
        //普通员工
        getMyClientPage(filterForm)
          .then((res) => {
            if (res.data && res.data.data) {
              this.listQuery.pageInfo.page = res.data.data.pageInfo.page + 1;
              this.customerList = this.customerList.concat(res.data.data.data || []);
              // 根据返回数据数量判断是否还有更多数据
              this.finished = !res.data.data.pageInfo.hasMore;
            } else {
              this.finished = true;
            }
          })
          .catch(() => {
            this.finished = true;
          })
          .finally(() => {
            this.loading = false;
            this.refreshing = false;
          });
      } else if (this.duty == 2 || this.duty == 3) {
        //企业老板
        getCorporationClientPage(filterForm)
          .then((res) => {
            if (res.data && res.data.data) {
              this.listQuery.pageInfo.page = res.data.data.pageInfo.page + 1;
              this.customerList = this.customerList.concat(res.data.data.data || []);
              // 根据返回数据数量判断是否还有更多数据
              this.finished = !res.data.data.pageInfo.hasMore;
            } else {
              this.finished = true;
            }
          })
          .catch(() => {
            this.finished = true;
          })
          .finally(() => {
            this.loading = false;
            this.refreshing = false;
          });
      } else if (this.duty == 99) {
        //管理员
        getAdminClientPage(filterForm)
          .then((res) => {
            if (res.data && res.data.data) {
              console.log('pageInfo:', res.data.data.pageInfo);
              console.log('hasMore:', res.data.data.pageInfo.hasMore);
              this.listQuery.pageInfo.page = res.data.data.pageInfo.page + 1;
              this.customerList = this.customerList.concat(res.data.data.data || []);
              // 根据返回数据数量判断是否还有更多数据
              this.finished = !res.data.data.pageInfo.hasMore;
              console.log('finished 设置为:', this.finished);
            } else {
              this.finished = true;
            }
          })
          .catch(() => {
            this.finished = true;
          })
          .finally(() => {
            this.loading = false;
            this.refreshing = false;
          });
      } else {
        this.finished = true;
        this.loading = false;
        this.refreshing = false;
      }
    },
    // 刷新客户列表
    onRefresh() {
      this.finished = false;
      this.refreshing = true;
      this.customerList = [];
      this.listQuery.pageInfo.page = 1;
      this.getSummary();
      this.onLoad();
    },
    // 打开修改对话框
    onEdit(item) {
      this.isAdding = false;
      this.currentLoanType = item.loanType;
      this.currentClientId = item.id;
      this.showEditDialog = true;
    },
    // 打开添加对话框
    showAddDialogFunc() {
      this.isAdding = true;
      this.currentClientId = '';
      this.showEditDialog = true;
    },

    // 格式化日期时间
    formatDateTime(date) {
      if (!date) return '';
      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      const hours = String(d.getHours()).padStart(2, '0');
      const minutes = String(d.getMinutes()).padStart(2, '0');
      const seconds = String(d.getSeconds()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    // 格式化借款金额
    formatMoney(money) {
      if (!money) return '0元';
      const num = Number(money);
      if (isNaN(num)) return money;
      if (num >= 10000) {
        return (num / 10000).toFixed(2) + '万';
      } else {
        return num + '元';
      }
    },
    // 获取人员列表
    getStaffList() {
      request.get('/User/Department/GetStaffList')
        .then((res) => {
          if (res.data && res.data.data) {
            this.staffOptions = res.data.data;
          }
        })
        .catch((error) => {
          console.error('获取人员列表失败:', error);
        });
    },
    // 选择人员
    selectStaff(item) {
      this.listQuery.salesmanId = item.id;
      this.showStaffPopup = false;
      this.onRefresh();
    },
    // 获取统计信息
    getSummary() {
      const params = {
        nameLike: this.listQuery.nameLike,
        bankName: this.listQuery.bankName,
        salesmanId: this.listQuery.salesmanId,
      };
      if (this.reportRecordId) {
        params.reportRecordId = this.reportRecordId;
      }
      if (this.loanType) {
        params.loanType = this.loanType;
      }
      request.post('/User/ClientInfo/Summary', params)
        .then((res) => {
          if (res.data && res.data.data) {
            this.summaryData = res.data.data;
          }
        })
        .catch((error) => {
          console.error('获取统计信息失败:', error);
        });
    },
    // 返回首页
    goToHome() {
      this.$router.push("/credit/home");
    },
    // 返回上一页
    goBack() {
      this.$router.back();
    },
  }
};
</script>

<style lang="less" scoped>
.page-container {
  width: 100%;
  min-height: 100vh;
  background-color: #F0F4FF;
}

.fixed-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  background-color: #ffffff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.enterprise-title {
  display: flex;
  align-items: center;
  background-color: #fff;
  padding: 12px;
  width: 100%;
  position: relative;
}

.back-icon {
  cursor: pointer;
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  flex-shrink: 0;
  margin-right: 12px;
}

.back-arrow {
  display: inline-block !important;
  width: 10px;
  height: 10px;
  border-left: 2px solid #333;
  border-bottom: 2px solid #333;
  transform: rotate(45deg);
  margin-right: 4px;
  visibility: visible !important;
  opacity: 1 !important;
}

.enterprise-text {
  position: absolute;
  left: 47.5%;
  transform: translateX(-50%);
  font-size: 18px;
  font-weight: 500;
}

.content-wrapper {
  padding-top: 170px;
  background-color: #F0F4FF;
  min-height: calc(100vh - 170px);
}

.content-wrapper.with-staff-filter {
  padding-top: 225px;
  min-height: calc(100vh - 225px);
}

.content-wrapper.no-header {
  padding-top: 0;
  min-height: 100vh;
}

.enterprise-card {
  margin: 12px 16px 0;
  padding: 16px;
  background-color: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: box-shadow 0.3s;
}

.enterprise-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.enterprise-card-content {
  flex: 1;
  min-width: 0;
}

.enterprise-card-row {
  display: flex;
  padding-bottom: 12px;
  margin-bottom: 12px;
  align-items: center;
  position: relative;
}

.enterprise-card-row::after {
  content: '';
  position: absolute;
  left: 80px;
  bottom: 0;
  right: 0;
  height: 1px;
  background: #E3E8F5;
}

.enterprise-card-row:last-child {
  margin-bottom: 0;
  padding-bottom: 0;
}

.enterprise-card-row:last-child::after {
  display: none;
}

.enterprise-card-row-title::after {
  display: block;
}

.enterprise-card-row-title .enterprise-card-value {
  font-weight: 500;
}

.enterprise-card-label {
  width: 80px;
  color: #666;
  font-size: 14px;
  flex-shrink: 0;
}

.enterprise-card-value {
  color: #333;
  font-size: 14px;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
}

.edit-icon {
  flex-shrink: 0;
  margin-left: auto;
  cursor: pointer;
  padding: 4px;
}

.enterprise-card-action {
  flex-shrink: 0;
  margin-left: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background-color: #EDF3FA;
  border-radius: 12px;
}

.button-row {
  position: fixed;
  bottom: 20px;
  left: 16px;
  right: 16px;
  padding: 10px 0;
  display: flex;
  align-items: center;
  gap: 12px;
  z-index: 999;
}

.button-row .btn-get-sub {
  flex: 1;
  margin: 0;
}

.home-button {
  width: 44px;
  height: 44px;
  background-color: #176FCA;
  border-radius: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  cursor: pointer;
  transition: background-color 0.3s;
  flex-shrink: 0;
}

.home-button:hover {
  background-color: #145EAB;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 60px 60px; 
  height: 80vh;
  width: 100%;
  margin: 0 auto;
  -webkit-align-items: center;
  -webkit-justify-content: center;
  -webkit-flex-direction: column;
  position: relative;
  box-sizing: border-box;
}

.empty-state .van-icon {
  display: block;
  margin: 0 auto;
  position: relative;
  left: 0;
  right: 0;
  text-align: center;
}

.empty-text {
  margin-top: 16px;
  color: #999;
  font-size: 14px;
  text-align: center;
  width: 100%;
}

.btn-get-sub {
  width: 100%;
  padding: 14px;
  border: none;
  border-radius: 12px;
  background: #1566C1;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.2s;
}

.search-container {
  display: flex;
  background: #fff;
  padding: 0px 6px;
}

.search-item {
  flex: 1;
  width: 50%;
  padding: 0px 6px;
}

.search-item ::v-deep .van-search__content {
  background: #F5F7FF;
  padding: 3px 0;
  border: 1px solid #E3E8F5;
  border-radius: 12px;
  padding-left: 12px;
}

.history-search-wrapper {
  padding: 12px;
  background: #fff;
}

.staff-search-wrapper {
  padding: 12px;
  background: #fff;
}

.staff-select {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 14px;
  background: #F5F7FF;
  border: 1px solid #E3E8F5;
  border-radius: 12px;
  cursor: pointer;
}

.staff-select:hover {
  border-color: #3a71ff;
  box-shadow: 0 2px 12px 0 rgba(58, 113, 255, 0.1);
}

.staff-select span {
  font-size: 0.9rem;
  color: #333;
}

.staff-popup {
  max-height: 80vh;
}

.summary-wrapper {
  display: flex;
  padding: 0px 12px 12px 12px;
  background: #fff;
  gap: 12px;
}

/* 当没有人员筛选时，summary-wrapper 与 search-container 之间增加间距 */
.search-container + .summary-wrapper {
  margin-top: 12px;
}

.summary-item-1 {
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 8px 12px;
  background: #F5F7FF;
  border-radius: 8px;
  gap: 8px;
}

.summary-item-2 {
  flex: 1.8;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 8px 12px;
  background: #F5F7FF;
  border-radius: 8px;
  gap: 8px;
}

.summary-label {
  font-size: 13px;
  color: #666;
}

.summary-value {
  font-size: 18px;
  font-weight: 600;
  color: #176FCA;
}

.history-select {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 14px;
  background: #F5F7FF;
  border: 1px solid #E3E8F5;
  border-radius: 20px;
  cursor: pointer;
}

.history-select:hover {
  border-color: #3a71ff;
  box-shadow: 0 2px 12px 0 rgba(58, 113, 255, 0.1);
}

.history-select span {
  font-size: 0.9rem;
  color: #333;
}

.history-popup {
  max-height: 80vh;
}

.popup-list {
  max-height: calc(80vh - 52px);
  overflow-y: auto;
}

.popup-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
  transition: background 0.2s;
}

.popup-item:last-child {
  border-bottom: none;
}

.popup-item:active {
  background: #f5f7ff;
}

.popup-item-text {
  font-size: 14px;
  color: #333;
}

.popup-empty {
  padding: 40px 16px;
  text-align: center;
  color: #999;
  font-size: 14px;
}

.popup-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  border-bottom: 1px solid #e4e7ed;
}

.popup-header h3 {
  margin: 0;
  font-size: 1rem;
  font-weight: bold;
  color: #333;
}

.popup-header .van-icon {
  cursor: pointer;
  color: #999;
}

.popup-header .van-icon:hover {
  color: #333;
}
</style>
